import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "../views/Login.vue";
import Unlock from "@/views/Unlock.vue";
import Home from "@/views/Home.vue";
import Timeline from "@/views/Timeline.vue";
import ActiviteDetail from "@/views/ActiviteDetail.vue";
import OpeVehicules from "@/views/OpeVehicules.vue";
import OpeActivites from "@/views/OpeActivites.vue";
import OpeActiviteCreation from "@/views/OpeActiviteCreation.vue";
import MonCalendrier from "@/views/MonCalendrier.vue";
import Recyclage from "@/views/Recyclage.vue";
import Benevoles from "@/views/Benevoles.vue";
import Benevole from "@/views/Benevole.vue";
import BenevoleCreate from "@/views/BenevoleCreate.vue";
import Profile from "@/views/Profile.vue";
import PasswordSecurity from "@/views/PasswordSecurity.vue";
import Onboarding from "@/views/Onboarding.vue";
import Tenues from "@/views/Tenues.vue";
import VerificationAssistee from "@/views/VerificationAssistee.vue";
import VerificationAssisteeLot from "@/views/VerificationAssisteeLot.vue";
import VerificationAssisteeMesVerifications from "@/views/VerificationAssisteeMesVerifications.vue";
import TechVerifications from "@/views/TechVerifications.vue";

// SCSS
import "../assets/scss/style.scss";
import { LocalStorageApp } from "@/utils/localstorage";
import { JwtManage } from "@/utils/jwt";
import { login, toast } from "@/store";
import { Http } from "@/utils/http";
import ErrorPage from "@/views/404.vue";
import { bus } from "@/main";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "BASE_URL",
    meta: {
      title: "Timeline PCP8",
      auth: false,
    },
    beforeEnter(to, from, next) {
      next("/accueil");
    },
  },
  {
    path: "/accueil",
    name: "Home",
    component: Home,
    meta: {
      title: "Accueil - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/timeline",
    name: "Timeline",
    component: Timeline,
    meta: {
      title: "Timeline - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: Onboarding,
    meta: {
      title: "Onboarding - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/mon-calendrier",
    name: "MonCalendrier",
    component: MonCalendrier,
    meta: {
      title: "Mon calendrier - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/mon-profil",
    name: "MonProfile",
    component: Profile,
    meta: {
      title: "Mon profil - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/securiser-mot-de-passe",
    name: "PasswordSecurity",
    component: PasswordSecurity,
    meta: {
      title: "Sécuriser mon mot de passe - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/recyclage",
    name: "Recyclage",
    component: Recyclage,
    meta: {
      title: "FC PSE - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/activites/gestions",
    name: "ActivitesGestions",
    component: OpeActivites,
    meta: {
      title: "Gestions des activités - PCP8",
      auth: true,
      roles: "OPE",
      allowedRoles: ["ADMIN", "OPE", "GA:VIEW"],
    },
  },
  {
    path: "/activite/:id",
    name: "ActivitesDetail",
    component: ActiviteDetail,
    meta: {
      title: "Activité - PCP8",
      auth: true,
      roles: "OPE",
      allowedRoles: ["ADMIN", "OPE", "GA:VIEW"],
    },
  },
  {
    path: "/tech/vehicules",
    name: "OpeVehicules",
    component: OpeVehicules,
    meta: {
      title: "Véhicules - PCP8",
      auth: true,
      roles: "USER",
      allowedRoles: ["ADMIN", "OPE", "GT:VEHI"],
    },
  },
  {
    path: "/tech/verifications",
    name: "TechVerifications",
    component: TechVerifications,
    meta: {
      title: "Vérifications - PCP8",
      auth: true,
      roles: "TECH",
      allowedRoles: ["ADMIN", "GT:VERIF"],
    },
  },
  {
    path: "/verification-assistee",
    name: "VerificationAssistee",
    component: VerificationAssistee,
    meta: {
      title: "Vérification assistée - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/verification-assistee/mes-verifications",
    name: "VerificationAssisteeMesVerifications",
    component: VerificationAssisteeMesVerifications,
    meta: {
      title: "Mes Vérification assistée - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/verification-assistee/lot-:lot",
    name: "VerificationAssisteeLot",
    component: VerificationAssisteeLot,
    meta: {
      title: "Vérification assistée - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/verification-assistee/activite-:activite",
    name: "VerificationAssisteeWithActivite",
    component: VerificationAssistee,
    meta: {
      title: "Vérification assistée - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/verification-assistee/activite-:activite/lot-:lot",
    name: "VerificationAssisteeWithActiviteLot",
    component: VerificationAssisteeLot,
    meta: {
      title: "Vérification assistée - PCP8",
      auth: true,
      roles: "USER",
    },
  },
  {
    path: "/activites/creer",
    name: "ActiviteCreer",
    component: OpeActiviteCreation,
    meta: {
      title: "Créer une activité - PCP8",
      auth: true,
      roles: "OPE",
      allowedRoles: ["ADMIN", "OPE", "GA:CREATE"],
    },
  },
  {
    path: "/administration/benevoles",
    name: "AdministrationBenevoles",
    component: Benevoles,
    meta: {
      title: "Bénévoles - PCP8",
      auth: true,
      roles: "NOUB",
      allowedRoles: ["ADMIN", "USR:VIEW", "USR:EDIT", "USR:COMP", "USR:HAB"],
    },
  },
  {
    path: "/administration/benevoles/creer",
    name: "AdministrationBenevolesCreer",
    component: BenevoleCreate,
    meta: {
      title: "Créer un bénévole - PCP8",
      auth: true,
      roles: "NOUB",
      allowedRoles: ["ADMIN", "USR:CREATE"],
    },
  },
  {
    path: "/administration/benevole/:id",
    name: "BenevoleDetail",
    component: Benevole,
    meta: {
      title: "Bénévole - PCP8",
      auth: true,
      roles: "NOUB",
      allowedRoles: ["ADMIN", "USR:VIEW", "USR:EDIT", "USR:COMP", "USR:HAB"],
    },
  },
  {
    path: "/tech/uniformes",
    name: "Tenues",
    component: Tenues,
    meta: {
      title: "Uniformes - PCP8",
      auth: true,
      roles: "LOC_TENUES",
    },
  },
  {
    path: "/go-photos",
    name: "GoPhotos",
    meta: {
      title: "Photos - PCP8",
      auth: true,
      roles: "USER",
    },
    beforeEnter() {
      const token = LocalStorageApp.getItem("pcp.token");
      window.location.href =
        "https://photos.protectioncivile-paris8.org/auth-vox.php?token=" +
        token;
    },
  },
  {
    path: "/go-wiki",
    name: "GoWiki",
    meta: {
      title: "Wiki - PCP8",
      auth: true,
      roles: "USER",
    },
    beforeEnter() {
      const token = LocalStorageApp.getItem("pcp.token");
      window.location.href =
        "https://wiki.protectioncivile-paris8.org/?token=" + token;
    },
  },
  {
    path: "/go-graphqlui",
    name: "GoGraphqlUi",
    meta: {
      title: "GraphQL UI - PCP8",
      auth: true,
      roles: "USER",
      allowedRoles: ["ADMIN", "GQL:DATA", "DEV:ACC", "DEV:GQL"],
    },
    beforeEnter() {
      const ctx = login.getContext;
      // DEV:ACC/DEV:GQL (ou ADMIN) se connecte avec son propre token Timeline, qui
      // donne accès à toutes les tables côté serveur GraphQL — pas besoin de clé dédiée.
      if (
        ctx?.roles.includes("ADMIN") ||
        ctx?.roles.includes("DEV:ACC") ||
        ctx?.roles.includes("DEV:GQL")
      ) {
        const timelineToken = LocalStorageApp.getItem("pcp.token");
        window.location.href =
          "https://ui.graphql.protectioncivile-paris8.org/?u=" + timelineToken;
        return;
      }
      const graphqlKey = ctx?.graphql_keys?.[0]?.key;
      if (!graphqlKey) {
        toast.pushError("Aucune clé GraphQL n'est associée à votre compte.");
        window.location.href = "/accueil";
        return;
      }
      window.location.href =
        "https://ui.graphql.protectioncivile-paris8.org/?u=" + graphqlKey;
    },
  },
  {
    path: "/go-graphqldata",
    name: "GoGraphqlData",
    meta: {
      title: "GraphQL Data - PCP8",
      auth: true,
      roles: "USER",
      allowedRoles: ["ADMIN", "GQL:DATA", "DEV:ACC", "DEV:GQL"],
    },
    beforeEnter() {
      const ctx = login.getContext;
      // DEV:ACC/DEV:GQL (ou ADMIN) se connecte avec son propre token Timeline, qui
      // donne accès à toutes les tables côté serveur GraphQL — pas besoin de clé dédiée.
      if (
        ctx?.roles.includes("ADMIN") ||
        ctx?.roles.includes("DEV:ACC") ||
        ctx?.roles.includes("DEV:GQL")
      ) {
        const timelineToken = LocalStorageApp.getItem("pcp.token");
        window.location.href =
          "https://data.graphql.protectioncivile-paris8.org/?u=" +
          timelineToken;
        return;
      }
      const graphqlKey = ctx?.graphql_keys?.[0]?.key;
      if (!graphqlKey) {
        toast.pushError("Aucune clé GraphQL n'est associée à votre compte.");
        window.location.href = "/accueil";
        return;
      }
      window.location.href =
        "https://data.graphql.protectioncivile-paris8.org/?u=" + graphqlKey;
    },
  },
  {
    path: "/go-sgbd",
    name: "GoSgbd",
    meta: {
      title: "SGBD - PCP8",
      auth: true,
      roles: "USER",
      // DEV:GQL n'ouvre pas cet accès : elle ne donne droit qu'à GraphQL.
      allowedRoles: ["ADMIN", "DEV:ACC"],
    },
    beforeEnter() {
      const timelineToken = LocalStorageApp.getItem("pcp.token");
      window.location.href =
        "https://data.protectioncivile-paris8.org/signon.php?token=" +
        timelineToken;
    },
  },
  {
    path: "/connexion",
    name: "Login",
    component: Login,
    meta: {
      title: "Connexion - PCP8",
      auth: false,
    },
  },
  {
    path: "/deverrouiller",
    name: "Unlock",
    component: Unlock,
    meta: {
      title: "Dévérouiller - PCP8",
      auth: false,
    },
  },
  {
    path: "/*",
    name: "404",
    component: ErrorPage,
    meta: {
      title: "404 - Timeline PCP8",
      auth: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  navigator.serviceWorker?.ready.then((registration) => {
    registration?.update();
  });

  if (to.meta && to.meta.auth) {
    const token = LocalStorageApp.getItem("pcp.token");
    if (token && JwtManage.isValid(`${token}`)) {
      await Http.sync();
      await login.context();
      const context = login.getContext;
      const allowedRoles = to.meta.allowedRoles as string[] | undefined;
      const hasAccess = allowedRoles
        ? allowedRoles.some(
            (r) =>
              context?.roles.includes(r) || context?.habilitations.includes(r)
          )
        : context?.roles.includes(to.meta.roles);
      if (hasAccess) {
        const mustChangePassword = LocalStorageApp.getItem<boolean>(
          "pcp.mustChangePassword"
        );
        if (mustChangePassword && to.path !== "/securiser-mot-de-passe") {
          const go = encodeURIComponent(to.fullPath);
          next(`/securiser-mot-de-passe?go=${go}`);
        } else if (
          context?.onboarding &&
          to.path !== "/onboarding" &&
          to.path !== "/recyclage" &&
          to.path !== "/securiser-mot-de-passe"
        ) {
          next("/onboarding");
        } else {
          next();
        }
      } else {
        bus.$emit("habilitationRequired", [true, to.meta.roles]);
        return false;
      }
    } else {
      const go = encodeURIComponent(to.fullPath);
      if (token) {
        next(`/deverrouiller?go=${go}`);
      } else {
        next(`/connexion?go=${go}`);
      }
    }
  }
  next();
});

router.afterEach((to) => {
  const title = to?.meta?.title ?? "PCP8";
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default router;
